module.exports = __webpack_public_path__ + "static/mlGif-385e50eb232d05f8faacbd25bc4a29a9.gif";